var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M386.6 520.8 363.4 497.6 512.4 349 661.4 497.6 638 520.8 528.8 411.6 528.8 895.2 495.8 895.2 495.8 411.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M798.6 367.2c0-2.4 0.4-4.8 0.4-7.2 0-128.6-105.6-232.8-233.6-232.8-92.2 0-171.6 54.2-208.8 132.6-16.2-8.2-34.2-12.8-53.6-12.8-59.2 0-108.2 47.2-117.8 104C114.8 375.2 64 444.4 64 523.6c0 99.4 80.2 180.4 179.2 180.4L426 704l0-32-181.2 0c-81.8 0-148.4-67-148.4-149.2 0-63.6 40.4-122.4 100.4-143.2l16.8-5.8 3-17.6c7.2-43.2 44.2-78.6 87.8-78.6 13.8 0 27.4 3.2 39.8 9.6l27 13.6 13-27.4c33.2-69.8 104.2-114.8 180.8-114.8 110.6 0 201.8 86.6 201.8 197.8 0 26.6-0.4 40.6-0.4 40.6l30.4 0.2C870 398.2 928 464 928 537.8c0 73.6-59.6 133.8-133 134.2l-6.4 0L594 672l0 32 202 0 0 0c90 0 164-74.6 164-165.6C960 447.4 889 367.4 798.6 367.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.bbacfcaaca7e30f95222912a52219574.svg";
export { ForwardRef as ReactComponent };